import { WaveAnimation } from "../../wave-animation/wave-animation";
import classNames from "classnames";
import { QuestionStatus } from "../../game-state/game-state.type";
import { playSound } from "../../game-state/games.functions";
import { useAppDispatch } from "../../../app/hooks";

export const SoundButton = (props: {
  playing: boolean;
  currentQuestionStatus: QuestionStatus;
  onClick: () => void;
}) => {
  const dispatch = useAppDispatch();
  return (
    <button
      onMouseEnter={() =>
        dispatch(playSound("sfx/select.mp3", undefined, 0.15))
      }
      className="w-full flex justify-center bg-blue-500 hover:bg-blue-600 cursor-pointer transition duration-200"
      onClick={props.onClick}
    >
      <div className="text-center text-white">
        {props.playing ? (
          <WaveAnimation />
        ) : (
          <div className="transition duration-200 transform hover:scale-110">
            <i
              className={classNames("fa fa-4x p-4", {
                "fa-hand-point-right":
                  props.currentQuestionStatus === "answered",
                "fa-volume-up": props.currentQuestionStatus !== "answered",
              })}
            />
          </div>
        )}
      </div>
    </button>
  );
};
